"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesListCtl = /** @class */ (function (_super) {
    __extends(AffilatesListCtl, _super);
    function AffilatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.identity; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_pprogram_domain = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_domain; });
        _this.dk_is_subagents = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_subagents; });
        _this.dk_subagents_percent_x100 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.subagents_percent_x100; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_admin_allowed_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.admin_allowed_count; });
        _this.dk_new_promo_contacts_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.new_promo_contacts_email; });
        _this.dk_new_promo_contacts_telegram = UIUtils_1.UIUtils.IProp2Str(function (o) { o.new_promo_contacts_telegram; });
        _this.dk_pprogram_contacts_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_contacts_email; });
        _this.dk_pprogram_contacts_telegram = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_contacts_telegram; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    AffilatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "affilate with id [" + id + "] not found !";
    };
    AffilatesListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListPProgramsGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    is_deprecated: resp.list[i].is_deprecated,
                    is_locked: resp.list[i].is_locked,
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    admin_allowed_count: resp.list[i].admins_allowed_cnt,
                    identity: resp.list[i].identity,
                    pprogram_domain: resp.list[i].pprogram_domain,
                    is_subagents: resp.list[i].is_subagents,
                    subagents_percent_x100: resp.list[i].subagents_percent_x100,
                    new_promo_contacts_email: resp.list[i].new_promo_contacts_email,
                    new_promo_contacts_telegram: resp.list[i].new_promo_contacts_telegram,
                    pprogram_contacts_email: resp.list[i].pprogram_contacts_email,
                    pprogram_contacts_telegram: resp.list[i].pprogram_contacts_telegram
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /*
                title: string;
            identity: string;
            description: string;
            is_deprecated: boolean;
            is_locked: boolean;
            pprogram_domain: string;
            is_subagents: boolean;
            subagents_percent_x100: number;
    
    */
    AffilatesListCtl.prototype.AddGws = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgram.exec({
            data: {
                title: data.title,
                description: data.description,
                is_locked: data.is_locked,
                is_deprecated: data.is_deprecated,
                identity: data.identity,
                pprogram_domain: data.pprogram_domain,
                is_subagents: data.is_subagents,
                subagents_percent_x100: data.subagents_percent_x100,
                new_promo_contacts_email: data.new_promo_contacts_email,
                new_promo_contacts_telegram: data.new_promo_contacts_telegram,
                pprogram_contacts_email: data.pprogram_contacts_email,
                pprogram_contacts_telegram: data.pprogram_contacts_telegram
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                title: data.title,
                description: data.description,
                is_locked: data.is_locked,
                is_deprecated: data.is_deprecated,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                admin_allowed_count: 0,
                identity: data.identity,
                pprogram_domain: data.pprogram_domain,
                is_subagents: data.is_subagents,
                subagents_percent_x100: data.subagents_percent_x100,
                new_promo_contacts_email: data.new_promo_contacts_email,
                new_promo_contacts_telegram: data.new_promo_contacts_telegram,
                pprogram_contacts_email: data.pprogram_contacts_email,
                pprogram_contacts_telegram: data.pprogram_contacts_telegram
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesListCtl.prototype.EditGws = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgram.exec({
                data: {
                    pprogram_id: data.key,
                    title: data.title,
                    description: data.description,
                    is_deprecated: data.is_deprecated,
                    is_locked: data.is_locked,
                    pprogram_domain: data.pprogram_domain,
                    is_subagents: data.is_subagents,
                    subagents_percent_x100: data.subagents_percent_x100,
                    new_promo_contacts_email: data.new_promo_contacts_email,
                    new_promo_contacts_telegram: data.new_promo_contacts_telegram,
                    pprogram_contacts_email: data.pprogram_contacts_email,
                    pprogram_contacts_telegram: data.pprogram_contacts_telegram
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_locked = data.is_locked;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.new_promo_contacts_email = data.new_promo_contacts_email;
                _tmp.new_promo_contacts_telegram = data.new_promo_contacts_telegram;
                _tmp.pprogram_contacts_email = data.pprogram_contacts_email;
                _tmp.pprogram_contacts_telegram = data.pprogram_contacts_telegram;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AffilatesListCtl.prototype.DeleteGws = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgram.exec({ data: { pprogram_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.SetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramIsDeprecated.exec({ data: { pprogram_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.SetIsLocked = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramIsLocked.exec({ data: { pprogram_id: key, is_locked: isDeprecated } }, function (resp) {
                _tmp.is_locked = isDeprecated;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.SetBannerTemplate = function (affilateId, templateBase64, onDone) {
        var _this = this;
        var _tmp = this.getById(affilateId);
        if (_tmp) {
            webAApi_1.DoEditPProgramTemplateBanner.exec({
                data: {
                    pprogram_id: affilateId,
                    template_banner_base64: templateBase64
                }
            }, function (resp) {
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.GetBannerTemplate = function (affilateId, onDone) {
        var _this = this;
        var _tmp = this.getById(affilateId);
        if (_tmp) {
            webAApi_1.DetailsPProgramTemplateBannerGet.exec({
                affilate_id: affilateId
            }, function (resp) {
                if (onDone) {
                    onDone(resp.template_banner_base64);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.SetBrandingTemplate = function (affilateId, templateBase64, onDone) {
        var _this = this;
        var _tmp = this.getById(affilateId);
        if (_tmp) {
            webAApi_1.DoEditPProgramTemplateBranding.exec({
                data: {
                    pprogram_id: affilateId,
                    template_branding_base64: templateBase64
                }
            }, function (resp) {
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesListCtl.prototype.GetBrandingTemplate = function (affilateId, onDone) {
        var _this = this;
        var _tmp = this.getById(affilateId);
        if (_tmp) {
            webAApi_1.DetailsPProgramTemplateBrandingGet.exec({
                pprogram_id: affilateId
            }, function (resp) {
                if (onDone) {
                    onDone(resp.template_branding_base64);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesListCtl;
}(BaseController_1.BaseController));
exports.AffilatesListCtl = AffilatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/AffilatesListCtl.ts
// module id = 872
// module chunks = 0